import {Store} from '@/lib/store';
import { observable, action, reaction } from 'mobx';
import { tokenParam } from '../interface';
import { validateAdmin } from './auth';

export default class AuthStore{

    Store: Store;
    constructor(Store: Store) {
        this.Store = Store;
    }

    @action validateAdmin = async (param:tokenParam) => {
        try 
        {   
            const list = await validateAdmin(param);

            return list.result;
        } catch (error) {
            throw error;
        }
    }

    
}
